<!-- 
  定时任务列表
  lovi 2020-08-01
 -->
<template>
  <div class="task-wrap">
    <div class="no-data" v-if="!taskList.length && getListFlag">
      <img
        :src="
          require('@/assets/images/public/no_data_' +
            (language == 'en' ? 'en' : 'cn') +
            '.png')
        "
      />
      <p>{{ $t("common.noData") }}</p>
    </div>
    <ul class="task-list" v-if="taskList.length && getListFlag">
      <li v-for="(item, index) in taskList" :key="index">
        <div class="task-left">
          <img src="@/assets/images/public/icon_batch.png" alt="" />
        </div>
        <div class="task-right">
          <div class="task-info">
            <p class="task-name">
              {{ item.label }}
              <span>
                {{
                  item.state == 1 ? $t("recharge.open") : $t("recharge.close")
                }}
              </span>
            </p>
            <p class="task-time">
              <span>
                {{
                  item.day == 0
                    ? $t("recharge.lastDayOfEveryMonth")
                    : language == "en"
                    ? item.day +
                      (item.day == 1
                        ? "st"
                        : item.day == 2
                        ? "nd"
                        : item.day == 3
                        ? "rd"
                        : "th") +
                      $t("recharge.everyMonth")
                    : $t("recharge.everyMonth") + item.day + $t("common.days")
                }}
              </span>
            </p>
          </div>
          <div class="task-handle">
            <p>
              <a @click="editItem(item)">
                {{ $t("common.edit") }}
              </a>
              <a class="text-orange" @click="deleteItem(item.timer_id)">
                {{ $t("common.delete") }}
              </a>
            </p>
            <p class="task-money">{{ item.money }}</p>
          </div>
        </div>
      </li>
    </ul>
    <div class="page-wrapper" v-if="totalPage > 0">
      <Page
        size="small"
        show-total
        :total="totalPage"
        :current.sync="page"
        @on-change="nextPage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    taskEditFlag: {
      //编辑开关
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      totalPage: 0,
      page: 1,
      taskList: []
    };
  },
  created() {
    this.timesRecord();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    editItem(data) {
      //编辑任务
      this.$emit("getTaskInfo", data);
      console.log("editItem", data);
    },
    deleteItem(id) {
      //删除任务
      let vm = this;
      this.$Modal.confirm({
        content: vm.$t("recharge.sureDeleteTask"),
        onOk: function() {
          let params = {};
          params.timer_id = id;
          vm.$post("/app/recharge/deltimes", params, {
            alert: true,
            loading: true
          }).then(res => {
            if (res.code == 0) {
              vm.$Message.success({
                content: res.msg,
                onClose: function() {
                  vm.timesRecord();
                }
              });
            } else {
              vm.$Message.error({
                content: res.msg,
                onClose: function() {}
              });
            }
          });
        },
        onCancel: function() {}
      });
    },
    timesRecord() {
      // 定时任务列表
      let vm = this;
      vm.getListFlag = false;
      vm.$post("/app/recharge/timesRecord", {}, { loading: true }).then(res => {
        console.log("timesRecord", res);
        vm.getListFlag = true;
        vm.taskList = res;
      });
    }
  },
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.task-wrap {
  padding: 0 50px;
}
.task-list {
  margin-top: 50px;
  li {
    display: flex;
    align-items: center;
    .task-left {
      flex: 0 0 50px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
    }
    .task-right {
      padding: 10px 0;
      flex-grow: 1;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      .task-name {
        font-size: 16px;
        span {
          margin-left: 20px;
          font-size: 12px;
        }
      }
      .task-time {
        font-size: 12px;
        color: #666666;
        span + span {
          margin-left: 20px;
        }
      }
      .task-money {
        padding-top: 5px;
        font-size: 16px;
        line-height: 1;
        text-align: right;
      }
      .task-handle {
        a {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
